import { useMutation, useQueryClient } from '@tanstack/react-query'

import { userTaskSpectatorRescuedService } from '../../../../../services/users-tasks/users-tasks-spectators/users-tasks-spectators-rescued'
import { USERS_TASKS_SPECTATORS_DEFAULTS_QUERY_KEY } from '../../defaults/users-tasks-spectators-defaults/use-get-users-tasks-spectators-defaults'
import { USER_TASK_SPECTATOR_FIRST_QUERY_KEY } from '../use-get-user-task-spectator'

export const useRescuedSpectatorTask = () => {
  const queryClient = useQueryClient()

  const { mutateAsync, isPending } = useMutation({
    mutationFn: userTaskSpectatorRescuedService.rescued,
    onSettled() {
      queryClient.invalidateQueries({
        queryKey: [USER_TASK_SPECTATOR_FIRST_QUERY_KEY],
        exact: false,
      })

      queryClient.invalidateQueries({
        queryKey: [USERS_TASKS_SPECTATORS_DEFAULTS_QUERY_KEY],
        exact: false,
      })
    },
  })

  return {
    isLoading: isPending,
    rescue: mutateAsync,
  }
}
